import { Component, inject } from '@angular/core';
import { PageContainerComponent } from '../../../layout/page-container/page-container.component';
import { DataTableSchema } from '../../../model/dynamic-data-table.model';
import { DynamicFormArray, Props } from '../../../model/form.model';
import { DealerTenureFilterSchema, DealerTenureHistory, DealerTenureHistorySearchConfig, DealerTenureProps, DealerTenureSearchConfig, DealerTenureTableSchema, DealerTenureTitle } from '../../../model/tenure/dealers-tenure.model';
import { SearchConfig } from '../../../model/api.model';
import { TenureBaseComponent } from '../tenure-base/tenure-base.component';
import { MatDialog } from '@angular/material/dialog';
import { TenureHistoryComponent } from "../tenure-history/tenure-history.component";
import { PaginatorService } from '../../../services/paginator-service.service';

@Component({
  selector: 'app-dealers-tenure',
  standalone: true,
  imports: [PageContainerComponent],
  providers: [PaginatorService],
  templateUrl: './dealers-tenure.component.html',
  styleUrl: './dealers-tenure.component.scss'
})
export class DealersTenureComponent extends TenureBaseComponent {

  protected override data: string = DealerTenureTitle;
  protected override props: Props = DealerTenureProps;
  protected override filterSchema: DynamicFormArray = structuredClone(DealerTenureFilterSchema);
  protected override dataTableSchema: DataTableSchema = structuredClone(DealerTenureTableSchema);
  protected override searchConfig: SearchConfig = structuredClone(DealerTenureSearchConfig);
    private userInfo = null;
    private readonly dialog = inject(MatDialog);
  override runCommonLogic(): void {
    this.updateLayoutButtonCallbacks();
    this.updateOptions();
    this.userInfo = JSON.parse(sessionStorage.getItem('UserInfo') ?? '');
    this.updateTableSchema();
  }
  updateTableSchema() {
    this.dataTableSchema.columnSchema.forEach(columnElm => {
      if (columnElm?.fieldType === 'Actions') {
        const actions = columnElm?.actionConfig;
        if (Array.isArray(actions) && actions.length > 0) {
          actions.forEach(action => {
            if (action.fieldKey === DealerTenureHistory) {
              action.onClick = this.showHistoryOnClick
            } 
          })
        }
      }
    })
  }
   showHistoryOnClick = (event: any) => {
      if (!this.userInfo) {
        this.commonUtils.showMatSnackBar("User-info data missing, Please try again after sometime");
        return
      }
      event.tenureConfig=DealerTenureHistorySearchConfig;
      const dialogRef = this.dialog.open(TenureHistoryComponent, {
        panelClass: 'tenure-history-dialog',
        data:event
      });
      const instance = dialogRef.componentInstance;
      instance.btnClose.subscribe(()=>{
        dialogRef.close()
      })
      instance.type = 'history';
    }
}
